import { Form, List, Tabs } from '@bynder/design-system';
import { WidgetAlignment } from '../../../types';
import {
  IconAlignLeft,
  IconAlignRight,
  IconAlignVerticalCenter,
  IconHorizontalConstraints,
} from '@bynder/icons';
import { useTranslate } from '@bynder/localization';
import { CSS_PROPERTIES } from './constants';

const AlignmentSettings = ({
  alignment,
  handleChange,
  label,
}: {
  alignment: WidgetAlignment;
  label: string;
  handleChange: (property: string, newAlignment: WidgetAlignment) => void;
}) => {
  const { translate } = useTranslate();

  const onChange = (widgetAlignment: WidgetAlignment) => {
    handleChange(CSS_PROPERTIES.JUSTIFY_CONTENT, widgetAlignment);
  };

  return (
    <Form.Row>
      <Form.Group>
        <List.Item>{label}</List.Item>
        <Tabs variant="clean">
          <Tabs.Tab
            data-testid="alignment-left"
            icon={<IconAlignLeft />}
            label={translate('WIDGET_INSPECTOR.CARD_ALIGNMENT_LEFT')}
            isLabelHidden
            isActive={alignment === WidgetAlignment.LEFT}
            onClick={() => {
              onChange(WidgetAlignment.LEFT);
            }}
          />
          <Tabs.Tab
            data-testid="alignment-center"
            icon={<IconAlignVerticalCenter />}
            isLabelHidden
            label={translate('WIDGET_INSPECTOR.CARD_ALIGNMENT_CENTER')}
            isActive={
              alignment === WidgetAlignment.CENTER || alignment === null
            }
            onClick={() => {
              onChange(WidgetAlignment.CENTER);
            }}
          />
          <Tabs.Tab
            data-testid="alignment-right"
            icon={<IconAlignRight />}
            isLabelHidden
            label={translate('WIDGET_INSPECTOR.CARD_ALIGNMENT_RIGHT')}
            isActive={alignment === WidgetAlignment.RIGHT}
            onClick={() => {
              onChange(WidgetAlignment.RIGHT);
            }}
          />
          <Tabs.Tab
            data-testid="alignment-space-between"
            icon={<IconHorizontalConstraints />}
            isLabelHidden
            label={translate('WIDGET_INSPECTOR.CARD_ALIGNMENT_SPACE_BETWEEN')}
            isActive={alignment === WidgetAlignment.SPACE_AROUND}
            onClick={() => {
              onChange(WidgetAlignment.SPACE_AROUND);
            }}
          />
        </Tabs>
      </Form.Group>
    </Form.Row>
  );
};

export default AlignmentSettings;
